export default {
  max_file_size_exceeded: 'Maximum file size is %{size} megabytes. Please upload smaller file',
  min_file_size_fail: 'Minimum file size is %{size} megabytes. Please upload bigger file',
  min_image_width_fail: 'Image width must be more than %{width}',
  min_image_height_fail: 'Image height must be more than %{height}',
  min_image_dimension_fail: 'Image width and height must be more than %{width}x%{height}',
  unsupported_extension: 'Sorry, but %{ext} is not supported',
  max_size: 'max %{size} Mb',
  fi_no_file_chosen: 'No file chosen',
  fi_upload_file: 'image/pdf (Max %{size}Mb)',
  fi_view_file: 'View file',
  fi_upload_iss_file: 'Pre-issuance asset file .iss',
  fi_upload_csv_file: 'Choose file(s) (up to %{size} mb)',
  file_incorrect_type: 'Wrong file format'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/file-upload.js